import { FC } from "react";

export const ReportAdminAvailibility : FC = () => {
    return (<>Reporte de disponibilidad</>)
}